module.exports = __webpack_public_path__ + "static/terri-b60715a6247bd299c2103bd4276d9af2.jpg";